const getters = {
    getDeviations: (state) => {
        return _.toArray(state.deviations);
    },
    getDeviationsOfCargo: (state) => (cargoId, ignoreTypes = [] ) => {
        return _.filter(state.deviations, deviation => {
            return deviation.cargoId === cargoId && ignoreTypes.indexOf(deviation.type) === -1;
        });
    },
    getDeviationsOfOrder: (state) => (orderId, ignoreTypes = [] ) => {
        return _.filter(state.deviations, deviation => {
            return deviation.orderId === orderId && ignoreTypes.indexOf(deviation.type) === -1;
        });
    },
    getDeviationsOfOrderProduct: (state) => (orderId, orderProductId, ignoreTypes = [], onlyFromLocations = [] ) => {
        return _.filter(state.deviations, deviation => {
            const isRightProductAndOrderAndType = deviation.recordId === orderProductId && deviation.orderId === orderId && ignoreTypes.indexOf(deviation.type) === -1;
            if (!isRightProductAndOrderAndType) {
                return false;
            } else {
                if (!deviation.pickLocationAtMomentOfRegistering) {
                    // If the deviation wasn't created on a picklocation: then always return since we dont know to which location it belongs too
                    // Maybe it was created before unloading
                    return true;
                } else if (onlyFromLocations.length === 0 || onlyFromLocations.indexOf(deviation.pickLocationAtMomentOfRegistering) > -1) {
                    // If the deviation is created on the same location as in the array: return true;
                    return  true;
                } else {
                    return false;
                }

            }
        });
    }
}

export default getters